// Canonical NCB proxy configuration and helpers
// All requests route through the Quest proxy with ?Instance=56134_gwaacademy.

const NCB_CONFIG = {
  conversationId: 'chat-05967525-c572-4f5d-9331-a84f3a57fef4',
  proxyBase: 'https://rmvzorxcl35mttidiexhtp5g2m0hpsqo.lambda-url.us-east-2.on.aws',
  instance: '56134_gwaacademy',
};

// Safe memory storage fallback when localStorage access is blocked in iframe/sandbox
const memoryStorage = {};

export function safeGetItem(key) {
  try {
    return window.localStorage ? localStorage.getItem(key) : (memoryStorage[key] || '');
  } catch (e) {
    return memoryStorage[key] || '';
  }
}

export function safeSetItem(key, value) {
  try {
    if (window.localStorage) {
      localStorage.setItem(key, value);
    }
  } catch (e) {
    /* fallback to memory */
  }
  memoryStorage[key] = String(value);
}

export function safeRemoveItem(key) {
  try {
    if (window.localStorage) {
      localStorage.removeItem(key);
    }
  } catch (e) {
    /* fallback to memory */
  }
  delete memoryStorage[key];
}

const SESSION_TOKEN_KEY = 'ncb_session_token';

function readSessionToken() {
  return safeGetItem(SESSION_TOKEN_KEY);
}

export function clearSessionToken() {
  safeRemoveItem(SESSION_TOKEN_KEY);
}

// Builds properly structured proxy URL with query params
export function buildProxyUrl(path) {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  const url = new URL(cleanPath, NCB_CONFIG.proxyBase);
  if (NCB_CONFIG.instance) {
    url.searchParams.set('Instance', NCB_CONFIG.instance);
  }
  return url.toString();
}

// Uniform request handler
async function ncbRequest(url, options = {}) {
  try {
    const token = readSessionToken();
    const res = await fetch(url, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...options.headers,
      },
      ...options,
    });
    const body = await res.json().catch(() => ({}));
    if (res.ok && body?.token) {
      safeSetItem(SESSION_TOKEN_KEY, body.token);
    }
    if (!res.ok) {
      return {
        status: 'error',
        data: null,
        error: body?.message || body?.error || `HTTP ${res.status}`,
        httpStatus: res.status,
      };
    }
    if (body && typeof body === 'object' && !Array.isArray(body) && typeof body.status === 'string' && 'data' in body) {
      return body;
    }
    return { status: 'success', data: body };
  } catch (err) {
    return { status: 'error', data: null, error: err?.message || 'Network error' };
  }
}

export async function authFetch(path, options = {}) {
  return ncbRequest(buildProxyUrl(`/auth/${path}`), options);
}

export async function dataFetch(path, options = {}) {
  return ncbRequest(buildProxyUrl(`/data/${path}`), options);
}

export async function publicDataFetch(path, options = {}) {
  return ncbRequest(buildProxyUrl(`/public-data/${path}`), options);
}

export default {
  buildProxyUrl,
  authFetch,
  dataFetch,
  publicDataFetch,
  config: NCB_CONFIG,
};